import { Components, tabClasses, Theme } from '@mui/material';

export const getMuiTab = (theme: Theme): Components['MuiTab'] => ({
  defaultProps: {
    disableRipple: true,
    disableTouchRipple: true,
  },
  styleOverrides: {
    root: {
      textTransform: 'none',
      fontFeatureSettings: "'case' on, 'cv11' on, 'calt' off",
      boxShadow: 'none',
      minHeight: 'unset',
      color: theme.palette.grey[600],

      '&:hover': {
        color: theme.palette.grey[900],
      },

      [`&.${tabClasses.selected}`]: {
        color: theme.palette.primary.main,
      },
    },
  },
});
